import cn from 'classnames';
import styles from './Button.module.css';

export type ButtonTheme = 'gray' | 'gray-secondary' | 'secondary' | 'tertiary' | 'black' | 'white';
export type ButtonRoundingSize = 'small' | 'medium' | 'max';

const commonClasses = 'h-10 w-10 text-black/30 hover:text-black transition-colors duration-300';

export const themeClasses: Record<ButtonTheme, string> = {
	gray: styles.gray,
	'gray-secondary': cn(commonClasses, 'bg-black/[.04] hover:bg-black/[.06]'),
	secondary: cn(commonClasses, 'hover:bg-black/[.06] group-hover:text-black group-hover:bg-black/[.06]'),
	tertiary: cn(commonClasses, 'group-hover:text-black'),
	black: cn(commonClasses, 'bg-black text-white h-auto px-4 py-2 hover:text-white'),
	white: cn(commonClasses, 'bg-white h-auto px-4 py-2'),
};

export const roundingSizeClasses: Record<ButtonRoundingSize, string> = {
	small: styles.smallRounding,
	medium: styles.mediumRounding,
	max: styles.maxRounding,
};
